import { EnvironmentTargetInterface } from '@environments/assets/environment-target.interface';

export const membershipApiTargets: EnvironmentTargetInterface = {
  build: {
    baseUrl: 'https://api.medlemskap.fagforbundet.build',
  },
  production: {
    baseUrl: 'https://api.medlemskap.fagforbundet.no',
  },
  staging: {
    baseUrl: 'https://api.medlemskap.fagforbundet.dev',
  },
};
